import React, { ReactNode, useState } from "react";
import { ProcessTreeItem } from "../../../../../@types";
import { BehaviorContext } from "./context";

const BehavioralProvider = ({ children }: { children: ReactNode }) => {
  const [active, setActive] = useState<ProcessTreeItem | undefined>(undefined);

  const context = { active, setActive };

  return (
    <BehaviorContext.Provider value={context}>
      {children}
    </BehaviorContext.Provider>
  );
};

export default BehavioralProvider;
